export function StatusBadge({ status }) {
  const map = {
    active: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    approved: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    paid: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    pending: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    unpaid: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    paused: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    rejected: "bg-red-500/15 text-red-400 border-red-500/30",
    cancelled: "bg-red-500/15 text-red-400 border-red-500/30",
    expired: "bg-slate-500/15 text-slate-400 border-slate-500/30",
    refunded: "bg-purple-500/15 text-purple-400 border-purple-500/30",
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border capitalize ${map[status] || map.expired}`}>
      {status}
    </span>
  );
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function daysLeft(iso) {
  if (!iso) return 0;
  const diff = new Date(iso) - new Date();
  return Math.max(0, Math.ceil(diff / 86400000));
}
